export default __webpack_public_path__ + "static/history-map-969ebef7d62e8b628959da0907ed8e5d.jpg";